import { formatNumberWithK } from '~/helpers'
import i18n from '~/i18n'
import { primary as theme } from '~/styles/themes'

import { formatCompareMetricLabel, formatStylesChart } from '../../helpers'
import { CreateDataset } from '../types'
import { OptionsScale } from './types'

const axisID = 'y-clicks'

const settings = {
  label: i18n.t('rm:metrics.clicks'),
  formatData: (value: number) => formatNumberWithK({ number: value }),
  color: theme.colors.primary,
  dataKey: 'clicksNumber' as keyof ReportHistoryCampaigns,
  order: 70
}

const dataset: CreateDataset = ({
  data,
  isCompare = false,
  selectedMetrics
}) => {
  const clicksViewsImpressions: AvailablePresets[] = [
    'clicks',
    'views',
    'impressions'
  ]

  const modifiersKeys = {
    clicksViewsImpressions: clicksViewsImpressions.every(value =>
      selectedMetrics?.includes(value)
    )
  }

  const modifiers = {
    style: modifiersKeys.clicksViewsImpressions ? 'bar' : 'line'
  }

  const type = modifiers.style as MixedChartType

  const handleOrder = () => {
    const order = isCompare ? settings.order - 1 : settings.order

    return type === 'line' ? order : order + 1
  }

  return {
    yAxisID: isCompare ? `${axisID}-compare` : axisID,
    type,
    label: formatCompareMetricLabel({ label: settings.label, isCompare }),
    data: data?.[settings.dataKey] || null,
    order: handleOrder(),
    ...formatStylesChart({
      color: settings.color,
      bgStyle: type === 'line' ? 'solid' : 'alphaGradient',
      isCompare
    })
  }
}

const optionsScale: OptionsScale = ({
  showScaleRuler = true,
  drawOnChartArea = true,
  position = 'left',
  isCompare = false
}) => ({
  [isCompare ? `${axisID}-compare` : axisID]: {
    display: showScaleRuler,
    position,
    grid: {
      // If true, draw lines on the chart area inside the axis lines. This is useful
      // when there are multiple axes and you need to control which grid lines are drawn.
      drawOnChartArea
    },
    beginAtZero: true,
    suggestedMin: 0,
    ticks: {
      z: 5,
      color: settings.color,
      callback: settings.formatData
    }
  }
})

const clicksPreset = { axisID, dataset, optionsScale, settings }

export default clicksPreset
